import { IBuilder, Builder } from 'builder-pattern';

export interface ForumMessageInterface {
  id: number;
  threadID: number;
  content: string;
  isDeleted: boolean;
  editedAt?: string;
  createdBy: {
    id: number;
    username: string;
    profilePictureURL?: string;
    smallProfilePictureURL?: string;
  };
  createdAt: string;
  updatedAt: string;
}

export namespace ForumMessageInterface {
  export function builder(
    template?: Partial<ForumMessageInterface>
  ): IBuilder<ForumMessageInterface> {
    return Builder<ForumMessageInterface>(template);
  }
}